import React from "react";
import {
  HeaderContainer,
  HeaderIconsContainer,
  HeaderIconsLinksContainer,
  HeaderLockupImg,
} from "./Header.styles";
import providerPortalLockup from "../../assets/logos/provider-portal/unity-horiz-cobranded-tint.svg";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";

export const BlankHeader: React.FC<{ link: string }> = ({ link }) => {
  const { deviceType } = useDeviceHook();
  return (
    <>
      <HeaderContainer>
        <HeaderIconsLinksContainer>
          <a
            href={link}
            target="_blank"
            rel="noreferrer"
            style={{ display: "flex" }}
          >
            <HeaderIconsContainer
              data-testid="HeaderIcons"
              paddingLeft={deviceType === "mobile" ? 10 : 40}
            >
              {import.meta.env.VITE_IS_USER_TESTING_ENV !== "true" && (
                <HeaderLockupImg
                  src={providerPortalLockup}
                  alt="Unity by BillionToOne"
                />
              )}
            </HeaderIconsContainer>
          </a>
        </HeaderIconsLinksContainer>
      </HeaderContainer>
    </>
  );
};
